// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recipe-name {
  border: none;
  font-size: 32pt;
  font-weight: bold;
  font-family: inherit;
}

.recipe-name-wrapper {
  flex: 0 0 content;
  display: inline-block;
}

.recipe-name-wrapper,
.recipe-name {
  background-color: inherit;
}

/* Hidden div used to size the input based on its content. */
.hidden {
  visibility: hidden;
  line-height: 0;
}
`, "",{"version":3,"sources":["webpack://./src/recipe-component/recipe_name.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":[".recipe-name {\n  border: none;\n  font-size: 32pt;\n  font-weight: bold;\n  font-family: inherit;\n}\n\n.recipe-name-wrapper {\n  flex: 0 0 content;\n  display: inline-block;\n}\n\n.recipe-name-wrapper,\n.recipe-name {\n  background-color: inherit;\n}\n\n/* Hidden div used to size the input based on its content. */\n.hidden {\n  visibility: hidden;\n  line-height: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
